export const tr = {
  navbar: {
    home: 'Ana Sayfa',
    gallery: 'Model Galerisi',
    tabGallery: 'Galeri',
    tabProfile: 'Profil',
    sellers: 'Satıcılar',
    about: 'Hakkımızda',
    contact: 'İletişim',
    signIn: 'Giriş Yap',
    signOut: 'Çıkış Yap',
    profile: 'Profilim',
    sellerPanel: 'Satıcı Paneli',
    adminPanel: 'Admin Paneli',
    moderatorPanel: 'Moderator Paneli',
    messages: 'Mesajlar',
    darkMode: '🌙 Karanlık Mod',
    lightMode: '☀️ Aydınlık Mod',
    logoutError: 'Çıkış yapılırken bir hata oluştu.',
    defaultUser: 'Kullanıcı',
  },
  hero: {
    title: "Türkiye'nin 3D Marketine Hoş Geldiniz!",
    subtitle: 'Binlerce 3D model, profesyonel tasarımcılar ve yerel üreticilerle buluşun. Hayalinizdeki projeleri gerçeğe dönüştürün, yaratıcılığınızı sınırların ötesine taşıyın!',
    cta: 'Hemen Başla',
    videoAlt: '3DEra platform tanıtım videosu - 3D baskı teknolojisi ve marketplace hizmetleri',
    videoFallback: 'Tarayıcınız video oynatmayı desteklemiyor. 3DEra platformunu keşfetmek için lütfen modern bir tarayıcı kullanın.',
  },
  footer: {
    faq: 'SSS',
    blog: 'Blog',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Koşulları',
    distanceSales: 'Mesafeli Satış Sözleşmesi',
    kvkk: 'KVKK Aydınlatma Metni',
    copyright: 'Tüm hakları saklıdır.',
    legalLinks: 'Yasal ve bilgi linkleri',
    tagline: '3D baskının buluşma noktası. Tasarla, sat, sipariş ver — hepsi tek yerde.',
    exploreHeading: 'Keşfet',
    legalHeading: 'Yasal & Destek',
    marketplace: 'Mağaza',
    sellers: 'Satıcılar',
    about: 'Hakkımızda',
    contact: 'İletişim',
    becomeSeller: 'Satıcı Ol',
    followUs: 'Bizi takip edin',
  },
  cookie: {
    message: 'Bu web sitesi, deneyiminizi iyileştirmek ve analitik amacıyla çerezler kullanmaktadır. Ayrıca üçüncü taraf reklam hizmetleri (Google AdSense) çerez kullanabilir. Detaylı bilgi için',
    privacyLink: 'Gizlilik Politikamızı',
    reviewText: 'inceleyebilirsiniz.',
    accept: 'Tümünü Kabul Et',
    reject: 'Reddet',
  },
  home: {
    seoDesc: "Türkiye'nin 3D model marketplace'i",
    featuredTitle: 'Öne Çıkan Modeller',
    featuredViewAll: 'Model Galerisi →',
    mostViewedTitle: 'En Çok Görüntülenen Modeller',
    noFeatured: 'Henüz öne çıkan ürün bulunmuyor.',
    price: '₺',
    valueProp: {
      heading: 'Hem kazanın, hem keşfedin',
      subheading: '3DEra, evde boş duran 3D printer\'ları olan üreticilerle uygun fiyata kaliteli ürün arayan alıcıları buluşturur.',
      sellerTitle: 'Evde 3D printer\'ınız mı var?',
      sellerDesc: 'Boş kapasitenizi gelire dönüştürün. Yakın çevrenizden gelen siparişlerle kendi şartlarınızda çalışın.',
      sellerBullet1: 'Komisyon yapısı şeffaf, kazandığınızı bilirsiniz',
      sellerBullet2: 'Kendi çalışma saatlerinizi belirleyin',
      sellerBullet3: 'Vergiden muaf veya şirket olarak kayıt seçeneği',
      sellerCtaGuest: '✨ Üye Ol ve Satmaya Başla',
      sellerCtaAuth: '🚀 Satıcı Ol',
      buyerTitle: 'Aradığınız ürünü uygun fiyata bulun',
      buyerDesc: 'Yerel üreticilerden hızlı kargoyla, hiçbir zahmet olmadan istediğiniz 3D ürüne sahip olun.',
      buyerBullet1: 'Samimi ve güvenilir yerel üreticiler',
      buyerBullet2: 'Hazır modeller veya özel tasarım siparişi',
      buyerBullet3: 'Hızlı kargo, güvenli teslimat',
      buyerCta: 'Ürünleri Keşfet',
    },
    blogTeaser: {
      heading: 'Blog\'dan',
      viewAll: 'Tümünü Gör',
      readMore: 'Devamını Oku',
      exploreAll: 'Devamını Keşfet',
    },
  },
  marketplace: {
    title: '3D Model Galerisi',
    subtitle: 'Binlerce hazır 3D model ve özel çizim dosyası arasından seçim yapın',
    readyModels: '📦 Hazır Modeller',
    customDrawings: '✏️ Özel Çizimler',
    searchPlaceholder: 'Ürün ara...',
    clearSearch: 'Aramayı temizle',
    ad: 'Reklam',
    filters: 'Filtreler',
    category: 'Kategori',
    all: 'Tümü',
    sortDefault: 'Varsayılan',
    sortNewest: 'En Yeni',
    sortPriceLow: 'Fiyat (Düşük)',
    sortPriceHigh: 'Fiyat (Yüksek)',
    sortPopular: 'Popüler',
    noProducts: 'Ürün bulunamadı.',
    loading: 'Yükleniyor...',
    featured: 'Öne Çıkan',
    categories: {
      figurine: 'Figür',
      decoration: 'Dekorasyon',
      toy: 'Oyuncak',
      jewelry: 'Takı & Aksesuar',
      functional: 'Fonksiyonel',
      architectural: 'Mimari',
      art: 'Sanat',
      other: 'Diğer',
    },
  },
  sellers: {
    title: 'Satıcılar',
    subtitle: 'Güvenilir 3D baskı hizmeti veren satıcılarımız',
    nearYou: 'Yakınındaki en iyi 3D yazıcı sahipleri',
    locationPrompt: 'Size En Yakın Satıcıları Görelim mi?',
    locationDesc: 'Konumunuza yakın 3D modelcileri bulmak için konum erişimine izin verin',
    allow: 'İzin Ver',
    notNow: 'Şimdi Değil',
    locationActive: 'Konumunuza göre en yakın satıcılar gösteriliyor',
    reset: 'Sıfırla',
    list: 'Liste',
    map: 'Harita',
    searchPlaceholder: 'Satıcı ismi, email veya uzmanlık alanı ara...',
    clearSearch: 'Aramayı temizle',
    found: 'satıcı bulundu',
    loading: 'Satıcılar yükleniyor...',
    demoData: 'Demo veriler gösteriliyor',
    previous: '‹ Önceki',
    next: 'Sonraki ›',
  },
  sellerProfile: {
    notFound: 'Satıcı bulunamadı',
    backToSellers: 'Satıcılara Dön',
    back: 'Geri',
    storeLogo: 'Mağaza logosu',
    defaultAvatar: 'Varsayılan avatar',
    design: 'Tasarım',
    printing: 'Baskı',
    designService: 'Tasarım Hizmeti',
    printingService: 'Baskı Hizmeti',
    reviews: 'değerlendirme',
    loading: 'Satıcı profili yükleniyor...',
    sendMessage: 'Mesaj Gönder',
    viewStore: 'Mağazayı Gör',
    products: 'Ürünler',
    location: 'Konum',
  },
  productDetail: {
    loading: 'Ürün yükleniyor...',
    notFound: 'Ürün Bulunamadı',
    backToMarketplace: "Marketplace'e Dön",
    back: 'Geri',
    gallery: 'Model Galerisi',
    fileAvailable: '3D Dosya Mevcut',
    zoomIn: 'Yakınlaştır',
    removeFromFavorites: 'Favorilerden Kaldır',
    addToFavorites: 'Favorilere Ekle',
    saved: 'Kaydedildi',
    save: 'Kaydet',
    share: 'Paylaş',
    shareText: 'Bu ürüne göz at:',
    linkCopied: 'Link kopyalandı!',
    description: 'Ürün Açıklaması',
    seller: 'Satıcı',
    viewStore: 'Mağazayı Gör',
    quantity: 'Adet',
    addToCart: 'Sepete Ekle',
    buyNow: 'Hemen Al',
  },
  about: {
    seoTitle: 'Hakkımızda - 3DEra',
    seoDesc: '3D baskı teknolojisini demokratikleştiren platform',
    title: 'Hakkımızda',
    heading: '3D Baskı Teknolojisini Demokratikleştiriyoruz',
    paragraph1: 'Merhaba! Biz 3D Era olarak, 3D baskı teknolojisini herkes için daha erişilebilir kılmayı hedefleyen genç bir girişimiz. Piyasadaki gözlemlerimiz bize gösterdi ki, 3D yazıcıların yüksek maliyeti ve teknik bilgi gerektirmesi, birçok kişinin bu teknolojiden faydalanmasını engelliyor.',
    paragraph2: 'Aynı zamanda, 3D yazıcı sahibi olup kullanmayan veya yeterince değerlendiremeyen birçok kişi olduğunu fark ettik. İşte tam da bu noktada, iki tarafı da mutlu edecek bir çözüm geliştirdik.',
    paragraph3: 'Platformumuz, 3D yazıcı sahiplerinin makinelerini değerlendirmelerine ve ek gelir elde etmelerine olanak sağlarken, 3D baskıya ihtiyaç duyan kullanıcıların da uygun fiyatlarla ve kolayca bu hizmete erişmelerini sağlıyor. Amacımız, 3D baskı teknolojisini demokratikleştirmek ve toplumun her kesiminin bu yenilikçi teknolojiden faydalanmasını sağlamak.',
    imageAlt: '3D baskı teknolojisi ile üretim',
    teamTitle: 'Ekibimiz',
    teamDesc: "Türkiye'nin 5 farklı şehrine dağılmış ekibimiz ile remote çalışarak 7/24 aktif hizmet sunuyoruz. Farklı lokasyonlardaki kontaklarımız sayesinde kullanıcılarımıza hızlı ve sorunsuz bir başlangıç süreci sağlıyoruz.",
    teamCities: '5+ Şehir',
    teamCitiesDesc: "Türkiye genelinde dağılmış ekip",
    teamRemote: 'Remote Çalışma',
    teamRemoteDesc: '7/24 aktif ve online destek',
    teamSupport: 'Hızlı Başlangıç',
    teamSupportDesc: 'Sorunsuz onboarding süreci',
  },
  contact: {
    title: 'İletişim & Destek',
    subtitle: 'Sorularınız, önerileriniz veya destek talepleriniz için buradayız. Size en kısa sürede dönüş yapacağız.',
    formTitle: 'Bizimle İletişime Geçin',
    formDesc: 'Aşağıdaki formu doldurarak bize ulaşabilirsiniz.',
    emailAlt: 'adresine de e-posta gönderebilirsiniz. Yanıt süremiz genellikle',
    hours24: '24 saat',
    within: 'içindedir.',
    maintenance: 'Site bakımda. Form şu an gönderilemez.',
    firstName: 'Ad',
    lastName: 'Soyad',
    email: 'E-posta',
    phone: 'Telefon',
    optional: 'Opsiyonel',
    subject: 'Konu',
    message: 'Mesaj',
    firstNamePlaceholder: 'Adınız',
    lastNamePlaceholder: 'Soyadınız',
    emailPlaceholder: 'ornek@email.com',
    phonePlaceholder: '05XX XXX XX XX',
    subjectPlaceholder: 'Mesajınızın konusu',
    messagePlaceholder: 'Mesajınızı buraya yazın...',
    attachment: 'Ek Dosya',
    dragFiles: 'Dosya sürükleyin veya',
    select: 'seçin',
    fileTypes: 'Görsel, video veya PDF — Maks.',
    fileLimit: 'dosya, 10MB',
    uploading: 'Dosyalar yükleniyor...',
    sending: 'Gönderiliyor...',
    maintenanceBtn: 'Bakımda',
    send: 'Gönder',
    success: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
    maxFiles: 'En fazla',
    filesLimit: 'dosya ekleyebilirsiniz.',
    unsupportedType: 'desteklenmeyen dosya türü. (Görsel, video veya PDF ekleyebilirsiniz)',
    fileTooLarge: 'çok büyük. Maksimum dosya boyutu 10MB.',
    fillRequired: 'Lütfen tüm zorunlu alanları doldurun.',
    rateLimit: 'Lütfen 1-2 dakika bekleyip tekrar deneyin.',
    sendFailed: 'Gönderilemedi. Lütfen tekrar deneyin.',
    genericError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    loginToAttach: 'Dosya eklemek için',
    signIn: 'giriş yapın',
    onlyLetters: 'Sadece harfler kullanabilirsiniz',
  },
  sss: {
    seoTitle: 'Sıkça Sorulan Sorular (SSS) - 3DEra',
    title: 'Sıkça Sorulan Sorular',
    subtitle: '3DEra hakkında merak ettiklerinizin cevaplarını burada bulabilirsiniz.',
    backHome: '← Ana Sayfa',
    notFound: 'Aradığınız cevabı bulamadınız mı?',
    contactUs: 'Bize Ulaşın →',
    general: 'Genel',
    forSellers: 'Satıcılar İçin',
    forBuyers: 'Alıcılar İçin',
    technical: 'Teknik',
    questions: {
      whatIs3DEra: { q: '3DEra nedir?', a: '3DEra, 3D baskı ürünlerinin alınıp satılabildiği bir dijital pazar yeridir. Satıcılar evlerinde boş duran 3D yazıcılarını gelir kaynağına dönüştürebilir; alıcılar ise maliyet açısından uygun fiyatlarla, neredeyse tüm ürünlerde ihtiyaçlarına yönelik özelleştirme imkânı bulabilir.' },
      isFree: { q: "3DEra'yı kullanmak ücretsiz mi?", a: "Evet, 3DEra'ya üye olmak ve ürünleri incelemek tamamen ücretsizdir. Satıcılar için de mağaza açmak ve ürün listelemek ücretsizdir. Sadece başarılı satışlardan küçük bir komisyon alınır." },
      fileFormats: { q: 'Hangi dosya formatları destekleniyor?', a: 'STL, OBJ, FBX, GLTF/GLB, STEP, IGES gibi popüler 3D dosya formatlarının yanı sıra PDF, DWG gibi teknik çizim formatları da desteklenmektedir.' },
      becomeSeller: { q: 'Nasıl satıcı olabilirim?', a: 'Hesap oluşturduktan sonra Profilim sayfanızdaki "Satıcı Ol" butonuna tıklayarak başvurunuzu yapabilirsiniz. Başvurunuz onaylandıktan sonra ürünlerinizi yüklemeye başlayabilirsiniz.' },
      approvalTime: { q: 'Ürünüm onaylanması ne kadar sürer?', a: 'Ürünler genellikle 6 saat içinde incelenir ve onaylanır. Yoğun dönemlerde bu süre biraz uzayabilir. Ürününüzün durumunu Satıcı Panelinizden takip edebilirsiniz.' },
      whatToSell: { q: 'Satıcı olarak ne tür ürünler satabilirim?', a: '3D baskı ile üretilmiş her türlü ürünü satabilirsiniz: dekoratif figürler, fonksiyonel parçalar, prototip ürünler, kişiselleştirilmiş hediyeler, takılar ve daha fazlası. Ürünlerin yasal ve platform kurallarına uygun olması yeterlidir.' },
      addEmployees: { q: 'Mağazama çalışan ekleyebilir miyim?', a: 'Evet, Satıcı Paneli\'ndeki "Ekip Yönetimi" bölümünden e-posta ile çalışan davet edebilirsiniz. Yönetici veya Çalışan rolü atayabilir, bitiş tarihi belirleyebilirsiniz.' },
      payment: { q: 'Ödeme nasıl yapılır?', a: 'Ödeme sistemi şu an entegrasyon aşamasındadır. Yakında güvenli ödeme altyapımız aktif olacaktır. Şu an satıcılarla doğrudan mesajlaşarak sipariş verebilirsiniz.' },
      trackOrder: { q: 'Siparişimi nasıl takip ederim?', a: 'Profilinizdeki sipariş geçmişi bölümünden siparişlerinizin durumunu anlık olarak takip edebilirsiniz. Ayrıca sipariş durumu değiştiğinde bildirim alırsınız.' },
      returns: { q: 'İade ve değişim yapabilir miyim?', a: 'Ürün açıklamasına uygun olmayan veya hasarlı gelen ürünler için iade talep edebilirsiniz. Detaylar için Mesafeli Satış Sözleşmemizi inceleyebilirsiniz.' },
      whatIs3DPrinting: { q: '3D baskı nedir?', a: '3D baskı (eklemeli üretim), dijital bir tasarımın katman katman fiziksel bir nesneye dönüştürülmesi işlemidir. FDM, SLA, SLS gibi farklı yöntemleri vardır. En yaygın yöntem olan FDM\'de eritilmiş plastik filament katmanlar halinde biriktirilerek ürün oluşturulur.' },
      photoTo3D: { q: 'Fotoğraftan 3D model oluşturabilir miyim?', a: 'Evet! 3DEra\'nın "Fotoğraftan 3D" özelliği ile fotoğrafınızı yükleyerek yapay zeka destekli 3D model tahmini alabilirsiniz. Bu özellik beta aşamasındadır.' },
      problem: { q: 'Bir sorunla karşılaştığımda ne yapmalıyım?', a: 'İletişim sayfamızdaki formu kullanarak bize ulaşabilirsiniz. Ayrıca sayfanın sağ tarafındaki "Geri Bildirim" butonu ile de hızlıca geri bildirim gönderebilirsiniz.' },
    },
  },
  blog: {
    seoTitle: 'Blog - 3D Baskı Rehberleri ve İpuçları | 3DEra',
    title: '3DEra Blog',
    subtitle: '3D baskı dünyası hakkında rehberler, ipuçları ve haberler',
    reading: 'okuma',
    readArticle: 'Makaleyi Oku →',
    ctaSubtitle: 'Daha fazla içerik için bizi takip etmeye devam edin.',
    comingSoon: 'Yakında →',
    newContent: 'Yeni içerikler hazırlanıyor. Takipte kalın!',
    backToBlog: '← Blog\'a Dön',
    relatedPosts: 'İlgili Yazılar',
    categories: { guide: 'Rehber', material: 'Malzeme', comparison: 'Karşılaştırma', business: 'İş', troubleshooting: 'Sorun Giderme' },
    posts: {
      whatIs3DPrinting: {
        title: '3D Baskı Nedir? Yeni Başlayanlar İçin Kapsamlı Rehber',
        excerpt: '3D baskı teknolojisinin temellerini, çalışma prensiplerini ve kullanım alanlarını keşfedin. FDM, SLA ve SLS yöntemlerini karşılaştırın.',
        content: `3D baskı, dijital bir tasarımı katman katman fiziksel bir nesneye dönüştüren bir üretim teknolojisidir. "Eklemeli üretim" olarak da bilinen bu yöntem, geleneksel üretim tekniklerinin aksine malzeme çıkarmak yerine malzeme ekleyerek çalışır.

## Nasıl Çalışır?

3D baskı süreci üç temel adımdan oluşur:

1. **Tasarım**: CAD yazılımları (Fusion 360, Tinkercad, Blender gibi) kullanılarak 3 boyutlu bir dijital model oluşturulur.
2. **Dilimleme**: Model, bir dilimleme yazılımı (Cura, PrusaSlicer gibi) ile ince katmanlara ayrılır ve yazıcı talimatlarına (G-code) dönüştürülür.
3. **Baskı**: 3D yazıcı, bu talimatları takip ederek malzemeyi katman katman biriktirerek nesneyi oluşturur.

## Yaygın 3D Baskı Yöntemleri

### FDM (Fused Deposition Modeling)
En yaygın ve uygun fiyatlı yöntemdir. Termoplastik filament eritilerek katman katman biriktirilir. Ev kullanıcıları ve hobi amaçlı projeler için idealdir.

### SLA (Stereolithography)
Sıvı reçineyi UV ışığıyla katılaştırarak çalışır. FDM'ye göre çok daha yüksek detay ve pürüzsüz yüzey sağlar. Minyatürler, takı kalıpları ve diş hekimliği uygulamalarında tercih edilir.

### SLS (Selective Laser Sintering)
Toz halindeki malzemeyi lazerle sinterleme yöntemidir. Destek yapısı gerektirmez ve endüstriyel uygulamalarda kullanılır.

## Nerelerde Kullanılır?

- **Prototipleme**: Ürün geliştirme sürecinde hızlı prototip üretimi
- **Eğitim**: Anatomi modelleri, mühendislik parçaları
- **Tıp**: Protezler, cerrahi planlama modelleri, diş implantları
- **Mimari**: Bina ve şehir maketleri
- **Hobi**: Figürler, ev dekorasyonu, cosplay parçaları
- **Endüstri**: Yedek parça, jig ve fikstürler

## İlk 3D Yazıcınızı Seçerken

Yeni başlayanlar için FDM yazıcılar en iyi seçenektir. 2.000-8.000 TL aralığında kaliteli başlangıç modelleri bulunur. Baskı alanı (en az 220x220mm), filament uyumluluğu ve topluluk desteği en önemli kriterlerdir.

3DEra'da, profesyonel tasarımcıların hazırladığı binlerce baskıya hazır modeli keşfedebilir ve kendi 3D baskı yolculuğunuza başlayabilirsiniz.`
      },
      filamentTypes: {
        title: 'En İyi 3D Yazıcı Filament Türleri ve Kullanım Alanları',
        excerpt: 'PLA, ABS, PETG, TPU ve daha fazlası. Hangi filament türü hangi projeye uygun? Avantajları ve dezavantajları ile karşılaştırmalı rehber.',
        content: `Filament seçimi, 3D baskı kalitesini doğrudan etkileyen en önemli faktörlerden biridir. Her filament türünün kendine özgü özellikleri, avantajları ve ideal kullanım alanları vardır.

## PLA (Polilaktik Asit)

PLA, en popüler ve yeni başlayanlar için en uygun filament türüdür.

- **Baskı sıcaklığı**: 190-220°C
- **Yatak sıcaklığı**: 20-60°C (opsiyonel)
- **Avantajları**: Kolay basılır, kokusuz, biyobozunur, geniş renk yelpazesi
- **Dezavantajları**: Düşük ısı dayanımı (55-60°C), kırılgan
- **İdeal kullanım**: Dekoratif objeler, prototipler, figürler, eğitim materyalleri

## ABS (Akrilonitril Bütadien Stiren)

Endüstriyel uygulamalarda tercih edilen dayanıklı bir filamenttir.

- **Baskı sıcaklığı**: 220-260°C
- **Yatak sıcaklığı**: 90-110°C (zorunlu)
- **Avantajları**: Yüksek ısı dayanımı, darbe direnci, aseton ile pürüzsüzleştirilebilir
- **Dezavantajları**: Warping sorunu, kötü koku, kapalı yazıcı gerektirir
- **İdeal kullanım**: Fonksiyonel parçalar, otomotiv parçaları, dış mekan kullanımı

## PETG (Polietilen Tereftalat Glikol)

PLA'nın kolay basılabilirliği ile ABS'nin dayanıklılığını birleştiren bir filamenttir.

- **Baskı sıcaklığı**: 220-250°C
- **Yatak sıcaklığı**: 70-90°C
- **Avantajları**: Güçlü, esnek, kimyasal dayanım, gıdaya uygun, UV direnci
- **Dezavantajları**: Stringing olabilir, PLA kadar kolay basılmaz
- **İdeal kullanım**: Mekanik parçalar, kaplar, dış mekan projeleri, gıda kapları

## TPU (Termoplastik Poliüretan)

Esnek ve kauçuk benzeri özelliklere sahip filamenttir.

- **Baskı sıcaklığı**: 210-230°C
- **Yatak sıcaklığı**: 30-60°C
- **Avantajları**: Esnek, darbe emici, aşınmaya dayanıklı
- **Dezavantajları**: Yavaş basılmalı, Bowden sistemlerde zor
- **İdeal kullanım**: Telefon kılıfları, ayakkabı tabanları, amortisör parçaları

## ASA (Akrilonitril Stiren Akrilat)

ABS'nin UV dayanımlı versiyonudur.

- **Baskı sıcaklığı**: 235-260°C
- **Avantajları**: UV ve hava koşullarına dayanıklı
- **İdeal kullanım**: Dış mekan parçaları, bahçe ekipmanları, araç parçaları

## Hangi Filamanti Seçmelisiniz?

| İhtiyaç | Önerilen Filament |
|---------|-------------------|
| Yeni başlıyorum | PLA |
| Dayanıklı parça lazım | PETG veya ABS |
| Esnek ürün istiyorum | TPU |
| Dış mekanda kullanacağım | ASA veya PETG |
| Detaylı figür basacağım | PLA veya PLA+ |

3DEra'daki satıcılar, ürünlerinde hangi filament türünü kullandıklarını belirtir. Bu sayede ihtiyacınıza en uygun ürünü kolayca bulabilirsiniz.`
      },
      prepareModel: {
        title: '3D Model Nasıl Hazırlanır? Tasarımdan Baskıya Adım Adım',
        excerpt: 'Dijital tasarımdan fiziksel ürüne geçiş sürecini öğrenin. Dilimleme ayarları, destek yapıları ve baskı optimizasyonu.',
        content: `3D baskıya başlamak için önce bir dijital modele ihtiyacınız var. Bu rehberde, model oluşturmadan baskıya kadar tüm süreci adım adım açıklıyoruz.

## Adım 1: 3D Model Edinme

Model edinmek için üç yolunuz var:

### Kendiniz Tasarlayın
- **Tinkercad**: Tamamen ücretsiz, tarayıcı tabanlı, yeni başlayanlar için ideal
- **Fusion 360**: Hobi kullanıcılarına ücretsiz, mühendislik projeleri için güçlü
- **Blender**: Ücretsiz, organik ve sanatsal modeller için mükemmel

### Hazır Model İndirin
3DEra'da binlerce baskıya hazır model bulabilirsiniz. STL veya OBJ formatında indirip doğrudan kullanabilirsiniz.

### 3D Tarama
Akıllı telefon uygulamaları veya tarayıcılarla gerçek nesneleri dijitalleştirin.

## Adım 2: Modeli Kontrol Edin

Baskıdan önce modelinizin "su geçirmez" (watertight) olduğundan emin olun:
- Açık kenarlar veya delikler olmamalı
- Normaller doğru yöne bakmalı
- Minimum duvar kalınlığı en az 1-2mm olmalı

Netfabb veya Meshmixer gibi araçlarla modeli onardıktan sonra baskıya hazırsınız.

## Adım 3: Dilimleme (Slicing)

Dilimleme yazılımı, 3D modelinizi yazıcının anlayacağı talimatlara çevirir.

### Temel Dilimleme Ayarları

- **Katman yüksekliği**: 0.2mm standart kalite, 0.12mm yüksek detay, 0.28mm hızlı baskı
- **Dolgu oranı**: %15-20 dekoratif, %40-60 fonksiyonel, %100 maksimum dayanıklılık
- **Baskı hızı**: 40-60 mm/s standart, detaylı baskılarda 30 mm/s
- **Destek yapıları**: Havada kalan bölgeler için otomatik destek ekleyin
- **Yapışma tipi**: Skirt (kenar çizgisi), Brim (geniş kenar) veya Raft (taban)

### Popüler Dilimleme Yazılımları
- **Cura**: Ücretsiz, en yaygın, geniş yazıcı desteği
- **PrusaSlicer**: Ücretsiz, gelişmiş ayarlar, organik destek
- **Bambu Studio**: Bambu Lab yazıcılara özel optimize edilmiş

## Adım 4: Baskı Süreci

1. Yazıcıyı hazırlayın: filament yükleyin, yatak seviyesi ayarlayın
2. İlk katmanı izleyin — yapışma iyi değilse baskıyı durdurun
3. Ortam sıcaklığını sabit tutun (ABS için kapalı ortam şart)
4. Baskı bitene kadar yazıcıyı yalnız bırakmayın (özellikle ilk baskılarda)

## Adım 5: Son İşlemler

- Destek yapılarını dikkatlice çıkarın
- Zımpara ile yüzeyi pürüzsüzleştirin (80-400 grit)
- Boyama için astar uygulayın
- Gerekirse epoksi veya dolgu macunu ile kusurları giderin

3DEra üzerinde satın aldığınız modeller genellikle önerilen baskı ayarlarıyla birlikte gelir. Bu sayede en iyi sonucu almanız kolaylaşır.`
      },
      fdmVsSla: {
        title: 'FDM vs SLA: Hangi 3D Baskı Yöntemi Size Uygun?',
        excerpt: 'İki popüler 3D baskı teknolojisinin detaylı karşılaştırması. Maliyet, kalite, hız ve kullanım kolaylığı açısından değerlendirme.',
        content: `3D baskı dünyasında iki ana teknoloji öne çıkar: FDM ve SLA. Her birinin kendine özgü avantajları ve kullanım alanları vardır. Peki hangisi sizin ihtiyaçlarınıza daha uygun?

## FDM (Fused Deposition Modeling)

FDM, erimiş plastik filamenti katman katman biriktirerek çalışan en yaygın 3D baskı yöntemidir.

### Avantajları
- Düşük malzeme maliyeti (1kg filament: 150-400 TL)
- Büyük baskı hacimleri mümkün
- Geniş malzeme seçeneği (PLA, ABS, PETG, TPU vb.)
- Bakım kolay, yedek parçalar ucuz
- Büyük ve aktif kullanıcı topluluğu

### Dezavantajları
- Katman çizgileri belirgin olabilir
- İnce detaylarda sınırlı
- Destek yapıları yüzey kalitesini düşürebilir
- Küçük parçalarda hassasiyet düşük

## SLA (Stereolithography)

SLA, sıvı fotopolimer reçineyi UV ışığıyla katılaştırarak çalışır. Çok daha yüksek çözünürlük sunar.

### Avantajları
- Olağanüstü yüzey kalitesi
- Çok ince detaylar (0.025mm katman)
- Pürüzsüz yüzey, minimum son işlem
- Minyatür ve takı kalıplarında mükemmel

### Dezavantajları
- Reçine maliyeti yüksek (1L: 400-1500 TL)
- Küçük baskı hacmi (genellikle)
- Toksik reçine, havalandırma ve koruyucu ekipman gerekli
- Baskı sonrası yıkama ve UV kürleme adımları
- Kırılgan sonuç (çoğu standart reçinede)

## Karşılaştırma Tablosu

| Özellik | FDM | SLA |
|---------|-----|-----|
| Başlangıç maliyeti | 2.000-8.000 TL | 5.000-15.000 TL |
| Malzeme maliyeti | Düşük | Yüksek |
| Yüzey kalitesi | Orta | Çok yüksek |
| Detay hassasiyeti | 0.1-0.2mm | 0.025-0.05mm |
| Baskı hızı | Orta-Hızlı | Yavaş-Orta |
| Bakım kolaylığı | Kolay | Zor |
| Güvenlik | Güvenli | Kimyasal riskler |
| Baskı hacmi | Büyük | Küçük-Orta |

## Hangisini Seçmelisiniz?

**FDM'yi seçin** eğer:
- 3D baskıya yeni başlıyorsanız
- Fonksiyonel parçalar ve prototipler basacaksanız
- Bütçeniz kısıtlıysa
- Büyük objeler basmanız gerekiyorsa

**SLA'yı seçin** eğer:
- Yüksek detaylı minyatürler veya takı basacaksanız
- Pürüzsüz yüzey kalitesi kritikse
- Küçük, detaylı parçalar üretecekseniz
- Diş hekimliği veya tıbbi modeller yapacaksanız

3DEra'daki satıcılar, hem FDM hem SLA baskı hizmeti sunmaktadır. Projenize uygun baskı yöntemini sunan satıcıyı kolayca bulabilirsiniz.`
      },
      sellingPrints: {
        title: '3D Baskı Ürünleri Satarak Para Kazanma Rehberi',
        excerpt: '3D yazıcınızı bir gelir kaynağına dönüştürün. 3DEra üzerinde mağaza açma, ürün listeleme ve satış stratejileri.',
        content: `3D yazıcınız sadece bir hobi aracı değil, aynı zamanda bir iş fırsatı olabilir. Bu rehberde, 3D baskı ürünleri satarak nasıl gelir elde edebileceğinizi anlatıyoruz.

## Neler Satabilirsiniz?

### Hazır 3D Modeller (Dijital Dosya)
- STL/OBJ dosyaları olarak satış
- Bir kez tasarla, sınırsız sat
- Üretim maliyeti yok, tamamen kar

### Baskılı Ürünler (Fiziksel)
- Dekoratif objeler, vazolar, saksılar
- Fonksiyonel parçalar, organizerlar
- Kişiselleştirilmiş hediyeler
- Cosplay aksesuarları ve figürler
- Telefon kılıfları ve tutucular

### Baskı Hizmeti
- Müşterilerin modellerini basma
- Tasarım + baskı paket hizmeti
- Prototip üretimi

## 3DEra'da Satışa Başlama

### 1. Satıcı Hesabı Oluşturun
3DEra'da "Satıcı Ol" sayfasından başvurunuzu yapın. Mağaza adınızı, satıcı tipinizi (tasarımcı, yazıcı veya her ikisi) ve bilgilerinizi girin.

### 2. Vergi Durumunuzu Seçin
Başvuru sırasında iki kayıt seçeneğinden birini seçmeniz gerekir:

- **Vergiden Muaf**: Bireysel satıcı iseniz vergi muafiyet yazınızı yüklersiniz. Satışlarınızda fatura kesme zorunluluğunuz olmaz.
- **Şirket / Firma**: Tüzel kişilik olarak satış yapacaksanız vergi levhanızı yüklersiniz ve satışlarda fatura kesersiniz.

Hangi durumun size uyduğundan emin değilseniz mali müşavirinize danışın.

### 3. Başvuru Onayı
Başvurunuz admin ekibimiz tarafından incelenir ve onaylanır. Onay sonrası mağazanız aktif olur.

### 4. Ürün Ekleme
Ürün fotoğrafları, açıklama, fiyat ve kategori bilgilerini girerek ürünlerinizi listeleyin. 3D dosya yükleyerek dijital model satışı da yapabilirsiniz.

### 5. Sipariş Yönetimi
Satıcı panelinizden gelen siparişleri takip edin, durumlarını güncelleyin ve müşterilerle iletişime geçin.

## Fiyatlandırma Stratejileri

- **Malzeme maliyeti**: Filament kullanımını hesaplayın (ağırlık x filament fiyatı/kg)
- **Elektrik ve amortisman**: Yazıcı ve elektrik giderlerini dahil edin
- **İşçilik**: Tasarım, hazırlık ve son işlem süreniz
- **Kar marjı**: Minimum %30-50 kar marjı hedefleyin
- **Pazar araştırması**: Benzer ürünlerin fiyatlarını inceleyin

## Başarı İçin İpuçları

1. **Kaliteli fotoğraflar çekin**: İyi aydınlatılmış, farklı açılardan çekilmiş fotoğraflar satışı artırır
2. **Detaylı açıklama yazın**: Boyut, malzeme, renk, kullanım alanı bilgilerini ekleyin
3. **Hızlı teslimat yapın**: Müşteri memnuniyeti ve iyi yorumlar için kargo süresini kısa tutun
4. **Müşterilerle iletişimde kalın**: 3DEra mesajlaşma sistemini aktif kullanın
5. **Portföyünüzü genişletin**: Düzenli olarak yeni ürünler ekleyin

3DEra, 3D baskı tutkunlarını bir araya getiren Türkiye'nin pazaryeridir. Hemen satıcı olun ve ürünlerinizi binlerce potansiyel müşteriye ulaştırın!`
      },
      troubleshooting: {
        title: '3D Baskı Sorunları ve Çözümleri',
        excerpt: 'Katman kayması, stringing, warping gibi yaygın sorunların nedenleri ve pratik çözüm yolları.',
        content: `Her 3D baskı kullanıcısı zaman zaman sorunlarla karşılaşır. Bu rehberde en yaygın sorunları ve kanıtlanmış çözümlerini bulacaksınız.

## 1. Warping (Eğilme/Bükülme)

Baskının köşeleri yataktan kalkar ve eğilir.

**Nedenleri:**
- Yatak sıcaklığı yetersiz
- Ortam sıcaklığı çok düşük
- İlk katman yapışması zayıf

**Çözümleri:**
- Yatak sıcaklığını artırın (PLA: 60°C, ABS: 100°C)
- Brim veya Raft kullanın
- Yatak yüzeyine yapıştırıcı stick veya hairspray uygulayın
- ABS için kapalı yazıcı kullanın
- İlk katman hızını %50 düşürün

## 2. Stringing (İplik Çekme)

Baskı nozülü hareket ederken ince iplikçikler bırakır.

**Nedenleri:**
- Geri çekme (retraction) ayarı yetersiz
- Nozül sıcaklığı çok yüksek
- Baskı hızı çok düşük

**Çözümleri:**
- Geri çekme mesafesini artırın (Bowden: 4-8mm, Direct Drive: 0.5-2mm)
- Geri çekme hızını 25-50 mm/s yapın
- Nozül sıcaklığını 5-10°C düşürün
- Seyahat hızını artırın (150-200 mm/s)

## 3. Katman Kayması (Layer Shifting)

Baskı belli bir noktadan sonra yana kayar.

**Nedenleri:**
- Kayışlar gevşek
- Motor sürücüleri aşırı ısınma
- Baskı hızı çok yüksek
- Nozül baskıya çarpıyor

**Çözümleri:**
- Kayışları sıkın (tıngırdamalı ama çok gergin olmamalı)
- Motor sürücü akımını kontrol edin
- Baskı hızını düşürün
- Z-offset'i kontrol edin

## 4. İlk Katman Yapışmama

İlk katman yatağa düzgün yapışmaz.

**Nedenleri:**
- Yatak terazisi bozuk
- Nozül yatağa çok yakın veya uzak
- Yatak kirli
- İlk katman hızı çok yüksek

**Çözümleri:**
- Yatağı yeniden seviyeleyin
- Z-offset'i ayarlayın (kağıt testi)
- Yatağı IPA (izopropil alkol) ile temizleyin
- İlk katman hızını 20-25 mm/s yapın
- İlk katman yüksekliğini artırın (%120-150)

## 5. Tıkanma (Clogging)

Filament nozülden çıkmaz veya düzensiz çıkar.

**Nedenleri:**
- Nozül sıcaklığı yetersiz
- Düşük kaliteli filament
- Heat break bölgesinde ısı kaçağı
- Nozül aşınmış

**Çözümleri:**
- Nozülü önerilen sıcaklığa ayarlayın
- Cold pull (soğuk çekme) yöntemiyle temizleyin
- Nozülü değiştirin (özellikle 0.4mm pirinç nozüller aşınır)
- Kaliteli filament kullanın
- Retraction mesafesini azaltın (heat creep önlemi)

## 6. Elephant Foot (Fil Ayağı)

İlk birkaç katman genişleyerek tabanı şişirir.

**Nedenleri:**
- Nozül yatağa çok yakın
- Yatak sıcaklığı çok yüksek
- İlk katman akışı fazla

**Çözümleri:**
- Z-offset'i hafifçe artırın
- Yatak sıcaklığını 5°C düşürün
- İlk katman akış oranını %95'e düşürün

## Genel İpuçları

- Her sorun giderme denemesinde **tek bir ayar değiştirin**
- Sıcaklık kulesi (temperature tower) basarak en iyi sıcaklığı bulun
- Düzenli bakım yapın: nozül temizliği, yatak kontrolü, kayış gerginliği
- Filamentleri kuru ortamda saklayın (nem kaliteyi düşürür)
- Topluluk forumlarında destek alın

3DEra'da 3D baskı konusunda deneyimli satıcılara doğrudan mesaj atarak teknik destek alabilirsiniz.`
      },
    },
  },
  auth: {
    signIn: 'Giriş Yap',
    signUp: 'Kayıt Ol',
    withGoogle: 'Google ile',
    continue: 'Devam Et',
    persistNote: 'Girişiniz bu cihazda kalıcı olacaktır (çıkış yapana kadar).',
    or: 'veya',
    firstName: 'Ad',
    lastName: 'Soyad',
    dateOfBirth: 'Doğum Tarihi',
    ageRequirement: '18 yaşından büyük olmalısınız',
    phoneOptional: 'Telefon (Opsiyonel)',
    email: 'E-posta',
    password: 'Parola',
    passwordExample: 'Örn: Sifre123!',
    minChars: 'En az 6 karakter',
    confirmPassword: 'Parola Tekrar',
    reenterPassword: 'Parolayı tekrar girin',
    passwordMismatch: '⚠️ Parolalar eşleşmiyor',
    terms: 'Kullanım Koşulları',
    termsAccept: 'okudum, kabul ediyorum.',
    kvkk: 'KVKK Aydınlatma Metni',
    kvkkAccept: 'kişisel verilerimin işlenmesini kabul ediyorum.',
    rememberMe: 'Beni Hatırla',
    processing: 'İşleniyor...',
    uppercaseReq: 'Parola en az 1 büyük harf içermelidir.',
    numberReq: 'Parola en az 1 rakam içermelidir.',
    specialReq: 'Parola en az 1 özel karakter (!@#$%^&* vb.) içermelidir.',
    underAge: '18 yaşından küçükler kayıt olamaz.',
    acceptTerms: 'Lütfen Kullanım Koşulları ve KVKK Aydınlatma Metnini okuyup kabul edin.',
    loginSuccess: 'Giriş başarılı! Hoş geldiniz 🎉',
    registerSuccess: 'Kayıt başarılı! Hesabınız oluşturuldu 🎉',
    googleError: 'Google ile giriş yapılırken bir hata oluştu.',
    accountDisabled: 'Hesabınız devre dışı bırakıldı. Bu hesapla giriş yapılamaz.',
    firstNameMin: 'Ad en az 2 karakter olmalıdır.',
    lastNameMin: 'Soyad en az 2 karakter olmalıdır.',
    enterEmail: 'Email adresi giriniz.',
    passwordsMismatch: 'Parolalar eşleşmiyor.',
    passwordMin: 'Parola en az 6 karakter olmalıdır.',
    passwordMax: 'Parola en fazla 50 karakter olabilir.',
    enterDob: 'Doğum tarihinizi giriniz.',
    phoneMin: 'Telefon numarası en az 10 hane olmalıdır.',
    unexpectedError: 'Beklenmeyen bir hata oluştu.',
    fillAllFields: 'Tüm alanları doldurun, parola gereksinimlerini karşılayın ve yasal metinleri kabul edin',
    uppercase: 'Büyük harf (A-Z)',
    number: 'Rakam (0-9)',
    specialChar: 'Özel karakter (!@#$%^&*)',
    onlyLetters: 'Sadece harfler kullanabilirsiniz',
    onlyNumbers: 'Sadece rakam ve boşluk kullanabilirsiniz',
    firstNameMax: 'Ad en fazla 50 karakter olabilir.',
    lastNameMax: 'Soyad en fazla 50 karakter olabilir.',
    phoneMax: 'Telefon numarası en fazla 15 hane olabilir.',
    emailMax: 'Email adresi en fazla 100 karakter olabilir.',
  },
  becomeSeller: {
    title: 'Satıcı Ol',
    alreadySeller: 'Zaten bir satıcı hesabınız var. Profil sayfanıza yönlendiriliyorsunuz.',
    storeNameMax: 'Mağaza adı en fazla 100 karakter olabilir.',
  },
  common: {
    loading: 'Yükleniyor...',
    error: 'Bir hata oluştu.',
    save: 'Kaydet',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    close: 'Kapat',
    back: 'Geri',
    next: 'İleri',
    previous: 'Önceki',
    search: 'Ara',
    noResults: 'Sonuç bulunamadı.',
    backHome: '← Ana Sayfa',
  },
  messages: {
    search: 'Konuşma ara...',
    noConversations: 'Henüz mesajınız yok',
    noMessages: 'Henüz mesaj yok. İlk mesajı gönderin!',
    typeMessage: 'Mesajınızı yazın...',
    hideConfirm: 'Bu konuşmayı kapatmak istediğinize emin misiniz?',
    deleteConfirm: 'Bu mesajı silmek istediğinize emin misiniz?',
    selectConversation: 'Bir konuşma seçin',
  },
};
